<script>
  import Button from '@components/buttons/button.svelte'
  import Modal from '@components/general/modal.svelte'
  import Text from '@components/general/text.svelte'
  import { Trash2 } from 'lucide-svelte'
  import { useForm, page } from '@inertiajs/svelte'

  let { onDelete, open = $bindable(false), showButton = true } = $props()

  let user = $derived($page.props.user)
  let confirmEmail = $state('')
  let confirmed = $derived(confirmEmail.toLowerCase() === user.email_address.toLowerCase())

  const form = useForm()

  function handleDelete() {
    $form.delete('/settings/profile', {
      onSuccess: () => onDelete?.(),
      onError: (errors) => {
        console.error(errors)
      }
    })
  }

  function handleClose() {
    open = false
    confirmEmail = ''
  }
</script>

{#if showButton}
  <Button variant="link" text="Delete account" class="text-red-400 hover:text-red-500" onclick={() => open = true} />
{/if}

<Modal bind:open title="Delete your account" width="32rem" onClose={handleClose}>
  
  <div class="flex flex-col gap-4">
    
    <Text class="text-gray-600">
      This will permanently delete your account and all associated data. You will lose access to all platform content, including any live session registrations and feedback you've submitted.
    </Text>

    <Text class="text-red-500 underline">
      This action cannot be undone.
    </Text>
    
    <div class="mt-2 flex flex-col gap-2">
      <label for="confirm-email" class="text-sm text-gray-500 mb-1 block">Type <strong>{user.email_address}</strong> to confirm</label>
      <input id="confirm-email" type="email" bind:value={confirmEmail} placeholder={user.email_address} class="input w-full" autocomplete="off" />
    </div>

  </div>

  {#snippet footer()}
    <Button variant="warning" text="Delete my account" Icon={Trash2} disabled={!confirmed} loading={$form.processing} onclick={handleDelete} />
  {/snippet}
</Modal>
